import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { Grid } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import IconButton from "./material-ui/IconButton";
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import Button from "@material-ui/core/Button";

import { postData } from "../../core/fetchService";
import { showInfo, showError } from "../../core/utils";

export const CheckSampleContent = ({modelParams, classes, options}) => {
    const { is_ext_asr, is_ext_nb, is_nb, server_url } = options;

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [checkSampleText, setCheckSampleText] = useState('')
    const [checkSampleInProgress, setCheckSampleInProgress] = useState(false)
    const [checkSampleResult, setCheckSampleResult] = useState('')

    const checkSample = () => {
        const trunc_floats = data => {
          const trunc = i => { const c = Number(i?.confidence); if (!isNaN(c)) i.confidence = c.toFixed(4) };
          trunc(data.intent);
          (data.intent_ranking || []).forEach(trunc);
          return data;
        };
        setCheckSampleInProgress(true);
        postData('/api/model/check_sample', 
          {
            _id: modelParams._id,
            model: modelParams,
            text: checkSampleText,
          },
          dispatch,
          data => {
            setCheckSampleResult(JSON.stringify(trunc_floats(data), null, 4));
          }, {
            on_error: e => { throw e },
          }).catch(e => {
            setCheckSampleResult(t('common.error') +': '+ e.message +'!');
          }).finally(() => 
              setCheckSampleInProgress(false)
          );
    };

    const FieldSection = ({ id, legend, ...props }) => {    
        const [isEmpty, setEmpty] = useState(true);
    
        useEffect(() => { setEmpty(!document.getElementById(id).innerText.trim()) });
    
        const copyToClipboard = id => async () => {
          let text = document.getElementById(id).innerText;
          try {
            await navigator.clipboard.writeText(text);
            showInfo(dispatch, t)('Content copied to clipboard');
          } catch (err) {
            const m = 'Failed to copy content to clipboard!';
            showError(dispatch, t)(m);
            console.error(m.slice(0,-1) +': ', err);
          }
        };

        return (
          <fieldset className={classes._fieldset} style={{width: "100%"}}>
            <legend className={classes.legend}>{legend}</legend>
            <div className={classes.inlineFloatRightIcon}>
              <IconButton
                title={t("common.copy_to_clipboard")}
                Icon={FileCopyOutlinedIcon}
                disabled={isEmpty}
                onClick={copyToClipboard(id)}
                fontSize='small'
              />
            </div>
            {props.children}
          </fieldset>
        )
      };

    return (
      <div style={{margin: 10}}>
        <Grid container spacing={3}>
            {!is_ext_asr && <div className={classes.checkSampleFirstRow}>
                <TextField
                    id="check_sample"
                    size="small"
                    label={t("train.check_sample_text")}
                    variant="outlined"
                    fullWidth
                    value={checkSampleText}
                    onChange={event => setCheckSampleText(event.target.value)}
                    autoFocus
                />
                <Button
                    disabled={!checkSampleText.trim() || checkSampleInProgress}
                    variant="outlined"
                    style={{ height: "40px", marginLeft: 10 }}
                    onClick={checkSample}
                >
                    {t("train.run_check_sample")}
                </Button>
            </div>}
            <FieldSection id="checkSampleCurl" legend={t('train.check_sample_curl')} classes={classes} dispatch={dispatch}>
                <div id="checkSampleCurl" style={{overflowWrap: 'anywhere'}}>
                {is_ext_nb ? `curl -s ${server_url}/predictions/${modelParams.remote_name} -H 'Content-Type: application/json' -d '{"inputs": {"text": "${checkSampleText}"} }'`
                    : is_ext_asr ? `curl -k --data-binary @audio.wav -H 'Transfer-Encoding: chunked' -H 'Content-Type: audio/x-pcm; rate=8000' -H 'Host: ${modelParams.remote_name}' ${server_url}`
                    : is_nb ? `curl -s ${server_url}/predictions/${modelParams.runtime_name} -H 'Content-Type: application/json' -d '{"inputs": {"text": "${checkSampleText}"} }'`
                    : '???'}
                </div>
            </FieldSection>
            {!is_ext_asr && <FieldSection id="checkSampleResult" legend={t('train.check_sample_result')} classes={classes} dispatch={dispatch}>
                <pre id="checkSampleResult" style={{ whiteSpace: 'pre-wrap', marginTop: 0, overflowWrap: 'anywhere' }}>
                    {checkSampleInProgress ? (checkSampleResult || '').replace(/[^\n]/g,'') : checkSampleResult}
                </pre>
            </FieldSection>}
        </Grid>
    </div>
    )
};